import React from "react";

const Pagination = ({ pages, currentPage, handle }) => {
  const SIZE_PAGINATION = 3;

  const pageNumbers = (total, max, current) => {
    const half = Math.floor(max / 2);
    let to = max;
    if (current + half >= total) {
      to = total;
    } else if (current > half) {
      to = current + half;
    }

    let from = Math.max(to - max, 0);
    return Array.from({ length: Math.min(total, max) }, (_, i) => i + 1 + from);
  };

  const totalPage = pageNumbers(pages, SIZE_PAGINATION, currentPage);

  const disabled = {
    start: () => currentPage === 1,
    prev: () => currentPage === 1 || currentPage > pages,
    next: () => currentPage >= pages,
    end: () => currentPage === pages,
  };

  //   BUTTON
  const StartPage = () => (
    <li
      className={`page-item ${disabled.start() ? "disable" : ""}`}
      onClick={() => handle(1)}
    >
      最初
    </li>
  );
  const PreviosPage = () => (
    <li
      className={`page-item ${disabled.prev() ? "disable" : ""}`}
      onClick={() => handle(currentPage - 1)}
    >
      {"<<"}
    </li>
  );
  const NextPage = () => (
    <li
      className={`page-item ${disabled.next() ? "disable" : ""}`}
      onClick={() => handle(currentPage + 1)}
    >
      {">>"}
    </li>
  );
  const LastPage = () => (
    <li
      className={`page-item ${disabled.end() ? "disable" : ""}`}
      onClick={() => handle(pages)}
    >
      最後
    </li>
  );

  return (
    <ul className="pagination news border-style py-3 px-3 px-md-0">
      <StartPage />
      <PreviosPage />
      {totalPage.map((item, index) => (
        <li
          key={index}
          onClick={() => handle(item)}
          className={`page-item ${currentPage === item ? "active" : ""}`}
        >
          {item}
        </li>
      ))}
      <NextPage />
      <LastPage />
    </ul>
  );
};

export default Pagination;
